// =============================================================================
//  Copyright : 2023 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : workshop support package
// =============================================================================
//~ export const dashpanels = true
export const parts = true;
// declare views with route and parts
import * as views from './views';
export { views };
